import React, { useState, useEffect } from "react";
import {
  Box, Card, CardContent, Typography, Table, TableContainer, Paper, Button,
  MenuItem, Select, Pagination, IconButton, Checkbox, FormControl, InputLabel,
  OutlinedInput, Stack, Chip, Grid, Drawer, Dialog, DialogTitle, DialogContent,
  Menu, ListItemIcon, ListItemText, TextField, Snackbar, CircularProgress, Alert,
  TableHead, TableRow, TableCell, TableBody, Tooltip
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useSelector } from "react-redux";
import { useAuthToken } from "../TokenContext";
import { useIntl } from "react-intl";
import { useHistory } from 'react-router-dom';
import moment from "moment";
import axios from "axios";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import {
  FilterList as FilterListIcon,
  Download as DownloadIcon,
  Edit as EditIcon,
  Save as SaveIcon,
  Cancel as CancelIcon,
  VideoCall as VideoCallIcon,
  DateRange as DateRangeIcon,
  ArrowUpward as ArrowUpwardIcon,
  ArrowDownward as ArrowDownwardIcon,
  PictureAsPdf as PictureAsPdfIcon,
  TableRows as TableRowsIcon
} from "@mui/icons-material";
import { DateRangePicker } from "react-date-range";
import { IoEyeOutline } from 'react-icons/io5';
import {
  AutoAwesome as AutoAwesomeIcon,
  Refresh as RefreshIcon,
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
  TrendingUp as TrendingUpIcon,
  TrendingDown as TrendingDownIcon,
  Warning as WarningIcon,
  CheckCircle as CheckCircleIcon,
  Speed as SpeedIcon,
  GitHub as GitHubIcon,
  Assignment as AssignmentIcon,
  HelpOutline as HelpOutlineIcon,
  ReportProblem as ReportProblemIcon
} from "@mui/icons-material";

import {



  Badge,
  Avatar,
  List,
  ListItem,
  Divider,
  Collapse

} from "@mui/material";
import { formatDistanceToNow } from 'date-fns';
import CommentIcon from "@mui/icons-material/Comment";
import CloseIcon from '@mui/icons-material/Close';
// Styled Components

const CommentDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    width: '600px',
    maxHeight: '80vh',
    backgroundColor: 'var(--artemy-bg-elevated)',
    backgroundImage: 'none',
    border: '1px solid var(--artemy-border)',
  },
}));

const CommentListItem = styled(ListItem)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  padding: '16px',
  '& .MuiListItemText-root': {
    margin: 0,
    color: 'var(--artemy-text-primary)'
  },
  '& .comment-header': {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    marginBottom: '8px',
  },
  '& .comment-metadata': {
    color: 'var(--artemy-text-secondary)',
    fontSize: '0.875rem',
  },
}));
const StyledCard = styled(Card)(() => ({
  height: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  backgroundColor: 'var(--artemy-bg-elevated)',
  border: '1px solid var(--artemy-border)',
  boxShadow: 'none',
  backgroundImage: 'none'
}));

const BriefContainer = styled(Box)(() => ({
  background: 'rgba(255, 255, 255, 0.01)',
  backdropFilter: 'blur(16px)',
  border: '1px solid var(--artemy-border, rgba(255, 255, 255, 0.08))',
  borderRadius: '16px',
  padding: '24px',
  marginBottom: '32px',
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.2)',
  '&:hover': {
    borderColor: 'rgba(91, 157, 235, 0.3)',
    boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.3)',
  }
}));

const HealthBadge = styled(Box)(({ health }) => {
  const isAtRisk = health === 'at_risk';
  return {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    padding: '6px 14px',
    borderRadius: '100px',
    fontSize: '11px',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    fontFamily: 'var(--artemy-font-mono, monospace)',
    background: isAtRisk ? 'rgba(255, 77, 106, 0.12)' : 'rgba(0, 212, 170, 0.12)',
    color: isAtRisk ? '#ff4d6a' : '#00d4aa',
    border: `1px solid ${isAtRisk ? 'rgba(255, 77, 106, 0.25)' : 'rgba(0, 212, 170, 0.25)'}`,
    boxShadow: `0 0 15px ${isAtRisk ? 'rgba(255, 77, 106, 0.08)' : 'rgba(0, 212, 170, 0.08)'}`,
    animation: 'briefPulse 2.5s infinite ease-in-out',
    '@keyframes briefPulse': {
      '0%, 100%': { transform: 'scale(1)', opacity: 0.95 },
      '50%': { transform: 'scale(1.03)', opacity: 1 }
    }
  };
});

const ParticipantBriefCard = styled(Card)(() => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: 'rgba(255, 255, 255, 0.02)',
  border: '1px solid var(--artemy-border, rgba(255, 255, 255, 0.08))',
  borderRadius: '12px',
  boxShadow: 'none',
  backgroundImage: 'none',
  transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
  '&:hover': {
    transform: 'translateY(-4px)',
    backgroundColor: 'rgba(255, 255, 255, 0.04)',
    borderColor: 'rgba(91, 157, 235, 0.25)',
    boxShadow: '0 12px 24px rgba(0, 0, 0, 0.3)'
  }
}));

const AiAssessmentBox = styled(Box)(() => ({
  fontStyle: 'italic',
  color: 'rgba(232, 236, 244, 0.9)',
  lineHeight: 1.6,
  padding: '14px 18px',
  borderRadius: '8px',
  background: 'rgba(255, 255, 255, 0.015)',
  borderLeft: '4px solid var(--artemy-accent, #9b5de5)',
  fontSize: '13px',
  position: 'relative',
  border: '1px solid rgba(255, 255, 255, 0.03)',
  borderLeftWidth: '4px'
}));

const ContentWrapper = styled(Box)(({ theme, collapsed }) => ({
  width: collapsed ? 'calc(100vw - 80px)' : 'calc(100vw - 260px)',
  maxWidth: collapsed ? 1400 : 1200,
  margin: '0 auto',
  marginLeft: collapsed ? "60px" : "240px",
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
  padding: theme.spacing(3),

  [theme.breakpoints.down('lg')]: {
    width: collapsed ? 'calc(100vw - 70px)' : 'calc(100vw - 250px)',
    maxWidth: collapsed ? 1200 : 1000,
    marginLeft: collapsed ? "50px" : "220px",
    padding: theme.spacing(3),
  },

  [theme.breakpoints.down('md')]: {
    width: collapsed ? 'calc(100vw - 60px)' : 'calc(100vw - 240px)',
    maxWidth: collapsed ? 1000 : 800,
    marginLeft: collapsed ? "40px" : "200px",
    padding: theme.spacing(2),
  },

  [theme.breakpoints.down('sm')]: {
    width: 'calc(100vw - 24px)',
    maxWidth: '100%',
    marginLeft: "12px",
    marginRight: "12px",
    padding: theme.spacing(2),
  },

  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
}));

const LoaderWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '400px',
  gap: '16px'
});

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  backgroundColor: 'rgba(var(--artemy-primary-rgb), 0.1)',
  color: 'var(--artemy-text-primary)',
  fontWeight: "bold",
  fontSize: "0.875rem",
  borderBottom: '1px solid var(--artemy-border)'
}));

// Custom Hooks
const useVideoHandling = (token, isLoggedIn, history) => {
  const handleVideoClick = async (loomUrl) => {
    if (!isLoggedIn) {
      sessionStorage.setItem('redirectAfterLogin', window.location.pathname);
      history.push('/login');
      return;
    }

    try {
      const [filename] = loomUrl.split('?')[0].split('/').slice(-1);
      const cloudFrontUrl = process.env.REACT_APP_CLOUDFRONTs3;
      const response = await axios.post(
        process.env.REACT_APP_TALENT_CLOUDFRONTAPI,
        { url: cloudFrontUrl + filename },
        { headers: { Authorization: token, 'Content-Type': 'application/json' } }
      );

      const { signedUrl } = JSON.parse(response.data.body);
      if (!signedUrl) throw new Error('Signed URL not found');

      const state = btoa(JSON.stringify({
        url: signedUrl,
        exp: Date.now() + (5 * 60 * 1000),
        isAuth: true
      }));

      window.open(`/video-viewer/${state}`, '_blank', 'width=1280,height=720');
    } catch (error) {
      console.error('Error handling video:', error);
      alert('Error accessing video. Please try again.');
    }
  };

  return handleVideoClick;
};

// Components
const SortableTableHeader = ({ column, label, sortConfig, onSort }) => (
  <th style={{ backgroundColor: 'var(--artemy-bg-base)', borderBottom: '1px solid var(--artemy-border)', padding: '16px', textAlign: 'left' }}>
    <div style={{
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      userSelect: 'none',
      color: 'var(--artemy-text-secondary)',
      fontFamily: 'var(--artemy-font-mono)',
      fontSize: '11px',
      textTransform: 'uppercase',
      letterSpacing: '0.05em'
    }}
      onClick={() => onSort(column)}>
      {label}
      <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '8px' }}>
        <ArrowUpwardIcon sx={{
          fontSize: '0.8rem',
          color: sortConfig.column === column && sortConfig.direction === 'asc' ? 'var(--artemy-accent)' : 'rgba(255,255,255,0.1)'
        }} />
        <ArrowDownwardIcon sx={{
          fontSize: '0.8rem',
          marginTop: '-8px',
          color: sortConfig.column === column && sortConfig.direction === 'desc' ? 'var(--artemy-accent)' : 'rgba(255,255,255,0.1)'
        }} />
      </div>
    </div>
  </th>
);

const AIUpdateModal = ({ open, onClose, data, intl }) => {
  if (!data) return null;

  return (
    <CommentDialog open={open} onClose={onClose} maxWidth="md">
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">AI Update - {data.firstName} {data.lastName}</Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        {data.Ai_update ? (
          <Box sx={{ p: 2 }}>
            <Typography variant="body1" style={{ whiteSpace: 'pre-wrap' }}>
              {data.Ai_update}
            </Typography>
          </Box>
        ) : (
          <Box p={3} textAlign="center">
            <Typography color="textSecondary">
              No AI Update available
            </Typography>
          </Box>
        )}
      </DialogContent>
    </CommentDialog>
  );
};

const CommentCell = ({ comments, activity_id, onCommentAdded }) => {
  const [open, setOpen] = useState(false);
  const [newComment, setNewComment] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const token = useAuthToken();
  const { user } = useSelector((state) => state.auth);

  // Parse comments string to array
  const parsedComments = comments ? JSON.parse(comments) : [];
  const commentCount = parsedComments.length;

  const handleAddComment = async () => {
    if (!newComment.trim() || !activity_id) return;

    setIsSubmitting(true);
    try {
      const commentObj = {
        id: parseInt(activity_id),
        user_id: parseInt(user.data[0].emp_id),
        new_text: newComment,
        is_reply: false,
        author: user.data[0].emp_firstname
      };

      const response = await axios.post(
        process.env.REACT_APP_CLIENT_ADDCOMENTPODACTIVITY,
        [commentObj],
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          }
        }
      );

      if (response.status === 200) {
        const newComments = [
          ...parsedComments,
          {
            text: newComment,
            user_id: parseInt(user.data[0].emp_id),
            author: user.data[0].emp_firstname,
            timestamp: new Date().toISOString(),
            replies: []
          }
        ];

        if (onCommentAdded) {
          onCommentAdded(activity_id, JSON.stringify(newComments));
        }

        setNewComment("");
      }
    } catch (error) {
      console.error("Error adding comment:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Tooltip title={`${commentCount} comments`}>
        <IconButton
          onClick={() => setOpen(true)}
          color={commentCount > 0 ? "primary" : "default"}
        >
          <Badge badgeContent={commentCount} color="primary">
            <CommentIcon />
          </Badge>
        </IconButton>
      </Tooltip>

      <CommentDialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">Comments History</Typography>
            <IconButton onClick={() => setOpen(false)}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          {parsedComments.length > 0 ? (
            <List>
              {parsedComments.map((comment, index) => (
                <React.Fragment key={comment.comment_id || index}>
                  <CommentListItem>
                    <div className="comment-header">
                      <Box display="flex" alignItems="center" gap={1}>
                        <Avatar sx={{ bgcolor: 'primary.main' }}>
                          {comment.author ? comment.author[0].toUpperCase() : 'U'}
                        </Avatar>
                        <Typography variant="subtitle2">
                          {comment.author || 'User'}
                        </Typography>
                      </Box>
                      <Typography variant="caption" className="comment-metadata">
                        {formatDistanceToNow(new Date(comment.timestamp), { addSuffix: true })}
                      </Typography>
                    </div>
                    <Typography variant="body1" style={{ whiteSpace: 'pre-wrap' }}>
                      {comment.text}
                    </Typography>
                    {comment.replies && comment.replies.length > 0 && (
                      <Box ml={4} mt={1}>
                        <Typography variant="subtitle2" color="textSecondary">
                          Replies:
                        </Typography>
                        {comment.replies.map((reply, replyIndex) => (
                          <Box key={replyIndex} mt={1} ml={2}>
                            <Typography variant="body2">{reply}</Typography>
                          </Box>
                        ))}
                      </Box>
                    )}
                  </CommentListItem>
                  {index < parsedComments.length - 1 && <Divider />}
                </React.Fragment>
              ))}
            </List>
          ) : (
            <Box p={3} textAlign="center">
              <Typography color="textSecondary">
                No comments yet
              </Typography>
            </Box>
          )}
          {/* Comment Form */}
          <Box sx={{
            mt: 2,
            pt: 2,
            borderTop: 1,
            borderColor: 'divider',
            position: 'sticky',
            bottom: 0,
            bgcolor: 'background.paper'
          }}>
            <TextField
              fullWidth
              multiline
              rows={2}
              variant="outlined"
              placeholder="Write a comment..."
              value={newComment}
              onChange={(e) => setNewComment(e.target.value)}
              sx={{ mb: 1 }}
            />
            <Button
              variant="contained"
              color="primary"
              onClick={handleAddComment}
              disabled={isSubmitting || !newComment.trim()}
              sx={{ float: 'right' }}
            >
              {isSubmitting ? <CircularProgress size={24} /> : 'Add Comment'}
            </Button>
          </Box>
        </DialogContent>
      </CommentDialog>
    </>
  );
};

const EditableTableRow = ({
  activity,
  onSave,
  selectedIds,
  handleCheckboxChange,
  token,
  isUserLoggedIn,
  handleVideoClick,
  handleCommentAdded,
  onAIUpdateView,
  intl
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [userStories, setUserStories] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // Parse initial Jira issues from activity
  const parseJiraIssues = (issueString) => {
    if (!issueString) return [];
    return issueString.split(',').map(issue => {
      const [key] = issue.split(':');
      return key.trim();
    });
  };

  // Initialize editedData with parsed Jira issues
  const [editedData, setEditedData] = useState({
    jira_issue: parseJiraIssues(activity.jira_issue),
    today_focus: activity.today_focus || "",
    accomplishments: activity.accomplishments || "",
    blockers: activity.blockers || "",
    loom_url: activity.loom_url || ""
  });

  // Fetch user stories when editing starts
  useEffect(() => {
    const fetchUserStories = async () => {
      if (!isEditing) return;

      setIsLoading(true);
      try {
        const response = await fetch(
          process.env.REACT_APP_CLIENT_JIRAISSUESLISTMANAGER,
          {
            method: 'POST',
            headers: {
              Authorization: token,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              pod_id: activity.pod_id,
              c_id: activity.created_by
            })
          }
        );

        const data = await response.json();
        if (data.statusCode === 200 && data.body) {
          const parsedBody = typeof data.body === 'string' ? JSON.parse(data.body) : data.body;
          if (Array.isArray(parsedBody.jiraIssues)) {
            setUserStories(parsedBody.jiraIssues);
          }
        }
      } catch (error) {
        console.error('Error fetching user stories:', error);
        setSnackbar({
          open: true,
          message: "Failed to load Jira issues",
          severity: "error"
        });
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserStories();
  }, [isEditing, activity.pod_id, activity.created_by, token]);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success"
  });

  const JiraIssueCell = ({ issueString }) => {
    if (!issueString) return null;

    // Parse the issue strings (handles multiple issues separated by commas)
    const parseIssues = (issuesStr) => {
      return issuesStr.split(',').map(issue => {
        const firstColonIndex = issue.indexOf(':');
        if (firstColonIndex === -1) return { key: issue.trim(), url: '' };

        return {
          key: issue.substring(0, firstColonIndex).trim(),
          url: issue.substring(firstColonIndex + 1).trim()
        };
      });
    };

    const issues = parseIssues(issueString);

    return (
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        {issues.map((issue, index) => (
          <Tooltip
            key={index}
            title={`Click to open ${issue.key} in Jira`}
            arrow
            placement="top"
          >
            <Chip
              label={issue.key}
              size="small"
              clickable
              onClick={() => {
                if (issue.url) {
                  window.open(issue.url, '_blank', 'noopener,noreferrer');
                }
              }}
              sx={{
                backgroundColor: theme => theme.palette.mode === 'dark' ? '#0277BD' : '#2196F3',
                color: 'white',
                '&:hover': {
                  backgroundColor: theme => theme.palette.mode === 'dark' ? '#0288D1' : '#1E88E5',
                  cursor: 'pointer'
                },
                transition: 'background-color 0.2s ease'
              }}
            />
          </Tooltip>
        ))}
      </Box>
    );
  };

  const handleSave = async () => {
    try {
      // Format Jira issues back to string with URLs
      const formattedJiraIssue = editedData.jira_issue.map(issueKey => {
        const issue = userStories.find(story => story.issue_key === issueKey);
        return issue ? `${issueKey}:${issue.issue_url || ''}` : issueKey;
      }).join(',');

      const poddata = [{
        pod_candidates: activity.firstName,
        ...editedData,
        jira_issue: formattedJiraIssue,
        id: activity.id
      }];

      const response = await fetch(
        process.env.REACT_APP_TALENTLEAD_PODACTIVITYUPDATELEAD,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: token
          },
          body: JSON.stringify({ poddata, status: 'draft' })
        }
      );

      if (!response.ok) throw new Error('Update failed');

      setSnackbar({
        open: true,
        message: "Successfully updated activity",
        severity: "success"
      });
      setIsEditing(false);
      if (onSave) onSave();
    } catch (error) {
      console.error("Error updating activity:", error);
      setSnackbar({
        open: true,
        message: "Failed to update activity",
        severity: "error"
      });
    }
  };

  const handleChange = (field) => (event) => {
    if (field === 'jira_issue') {
      setEditedData(prev => ({
        ...prev,
        [field]: event.target.value
      }));
    } else {
      setEditedData(prev => ({
        ...prev,
        [field]: event.target.value
      }));
    }
  };

  return (
    <>
      <tr style={{
        transition: 'background-color 0.2s',
        backgroundColor: isEditing ? 'rgba(255,255,255,0.05)' :
          activity.posted_to_client === 1 ? 'rgba(255,255,255,0.02)' : 'transparent',
        borderBottom: '1px solid rgba(255,255,255,0.05)'
      }}>
        <td style={{ padding: '16px' }}>
          <Checkbox
            checked={selectedIds.includes(activity.id)}
            onChange={(e) => handleCheckboxChange(e, activity.id)}
            disabled={activity.posted_to_client === 1 || isEditing}
            sx={{ color: 'var(--artemy-text-dim)', '&.Mui-checked': { color: 'var(--artemy-primary)' } }}
          />
        </td>
        <td style={{ padding: '16px', color: 'var(--artemy-text-primary)', fontSize: '13px' }}>{activity.firstName}</td>
        <td style={{ padding: '16px' }}>
          {isEditing ? (
            <FormControl fullWidth size="small">
              <Select
                multiple
                value={editedData.jira_issue}
                onChange={handleChange('jira_issue')}
                displayEmpty
                disabled={isLoading}
                renderValue={(selected) => {
                  if (selected.length === 0) return 'Select Jira Issues';
                  return selected.join(', ');
                }}
                sx={{ background: 'var(--artemy-bg-base)', color: 'var(--artemy-text-primary)' }}
              >
                {userStories.map((story) => (
                  <MenuItem key={story.issue_key} value={story.issue_key}>
                    <Checkbox checked={editedData.jira_issue.indexOf(story.issue_key) > -1} />
                    <ListItemText
                      primary={story.issue_key}
                      secondary={story.issue_summary}
                      sx={{ whiteSpace: 'normal' }}
                    />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          ) : (
            <JiraIssueCell issueString={activity.jira_issue} />
          )}
        </td>
        {['today_focus', 'accomplishments'].map(field => (
          <td key={field} style={{ padding: '16px', color: 'var(--artemy-text-secondary)', fontSize: '13px', maxWidth: '250px' }}>
            {isEditing ? (
              <textarea
                className="artemy-input"
                style={{ width: '100%', minHeight: '60px', padding: '8px', fontSize: '13px' }}
                value={editedData[field]}
                onChange={handleChange(field)}
              />
            ) : (
              <div style={{ wordBreak: 'break-word' }}>
                {activity[field]}
              </div>
            )}
          </td>
        ))}
        <td style={{ padding: '16px' }}>
          {isEditing ? (
            <input
              className="artemy-input"
              style={{ width: '100%', padding: '8px', fontSize: '13px' }}
              value={editedData.loom_url}
              onChange={handleChange('loom_url')}
              placeholder="Enter video URL"
            />
          ) : (
            activity.loom_url && isUserLoggedIn && (
              <Button
                variant="text"
                size="small"
                onClick={() => handleVideoClick(activity.loom_url)}
                startIcon={<VideoCallIcon />}
                sx={{ textTransform: 'none', color: 'var(--artemy-primary)' }}
              >
                View Video
              </Button>
            )
          )}
        </td>
        <td style={{ padding: '16px' }}>
          {activity.Ai_update ? (
            <Tooltip title="View AI Update" arrow>
              <IconButton
                onClick={() => onAIUpdateView(activity)}
                size="small"
                sx={{ color: 'var(--artemy-primary)', '&:hover': { backgroundColor: 'rgba(var(--artemy-primary-rgb), 0.1)' } }}
              >
                <IoEyeOutline size={20} />
              </IconButton>
            </Tooltip>
          ) : (
            <span style={{ color: 'var(--artemy-text-dim)', fontSize: '13px' }}>-</span>
          )}
        </td>
        <td style={{ padding: '16px' }}>
          <CommentCell
            comments={activity.comments || '[]'}
            activity_id={activity.id}
            onCommentAdded={handleCommentAdded}
          />
        </td>
        <td style={{ padding: '16px', color: 'var(--artemy-text-secondary)', fontSize: '12px' }}>
          {moment(activity.createdAt).format('MM-DD-YYYY')}
        </td>
        <td style={{ padding: '16px' }}>
          <span style={{ fontSize: 12, padding: '4px 8px', borderRadius: 4, display: 'inline-flex', alignItems: 'center', gap: 4, color: activity.posted_to_client === 1 ? 'var(--artemy-green)' : 'var(--artemy-orange)', background: activity.posted_to_client === 1 ? 'rgba(0,212,170,.1)' : 'rgba(255,153,0,.1)' }}>
            {activity.posted_to_client === 1
              ? intl.formatMessage({ id: "approved" })
              : intl.formatMessage({ id: "pending" })
            }
          </span>
        </td>
        <td style={{ padding: '16px' }}>
          <Stack direction="row" spacing={1}>
            {!activity.posted_to_client && !isEditing && (
              <IconButton
                size="small"
                onClick={() => setIsEditing(true)}
                sx={{ color: 'var(--artemy-text-secondary)', '&:hover': { color: 'var(--artemy-primary)' } }}
              >
                <EditIcon fontSize="small" />
              </IconButton>
            )}
            {isEditing && (
              <>
                <IconButton size="small" onClick={handleSave} sx={{ color: 'var(--artemy-green)' }}>
                  <SaveIcon fontSize="small" />
                </IconButton>
                <IconButton
                  size="small"
                  onClick={() => {
                    setEditedData({
                      jira_issue: activity.jira_issue || "",
                      today_focus: activity.today_focus || "",
                      accomplishments: activity.accomplishments || "",
                      blockers: activity.blockers || "",
                      loom_url: activity.loom_url || ""
                    });
                    setIsEditing(false);
                  }}
                  sx={{ color: 'var(--artemy-red)' }}
                >
                  <CancelIcon fontSize="small" />
                </IconButton>
              </>
            )}
          </Stack>
        </td>
      </tr>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ background: 'var(--artemy-bg-elevated)', color: 'var(--artemy-text-primary)' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

const PodActivity = ({ collapsed }) => {
  const [selectedPodId, setSelectedPodId] = useState([]);
  const [podDetails, setPodDetails] = useState([]);
  const [podActivities, setPodActivities] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const token = useAuthToken();
  const [filteredActivities, setFilteredActivities] = useState([]);
  const [selectedTeamMember, setSelectedTeamMember] = useState("");
  const [selectedIds, setSelectedIds] = useState([]);
  const [showDateRangePicker, setShowDateRangePicker] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [downloadMenuAnchor, setDownloadMenuAnchor] = useState(null);
  const [userStories, setUserStories] = useState([]);
  const [tempDateRange, setTempDateRange] = useState([{
    startDate: moment().subtract(7, "days").toDate(),
    endDate: moment().toDate(),
    key: "selection"
  }]);
  const { isLoggedIn, user } = useSelector((state) => state.auth);
  const intl = useIntl();
  const [isLoading, setIsLoading] = useState(true);
  const [statusFilter, setStatusFilter] = useState("all");
  const history = useHistory();
  const handleVideoClick = useVideoHandling(token, isLoggedIn, history);
  const [aiUpdateModalOpen, setAiUpdateModalOpen] = useState(false);
  const [selectedAIUpdateData, setSelectedAIUpdateData] = useState(null);

  // Add these handlers after existing handlers:
  const handleAIUpdateView = (data) => {
    setSelectedAIUpdateData(data);
    setAiUpdateModalOpen(true);
  };

  const handleCloseAIUpdateModal = () => {
    setAiUpdateModalOpen(false);
    setSelectedAIUpdateData(null);
  };
  const [dateRange, setDateRange] = useState([{
    startDate: moment().subtract(7, "days").toDate(),
    endDate: moment().toDate(),
    key: "selection"
  }]);

  const [sortConfig, setSortConfig] = useState({
    column: "createdAt",
    direction: "desc"
  });

  const [dailyBrief, setDailyBrief] = useState(null);
  const [isBriefLoading, setIsBriefLoading] = useState(false);
  const [briefError, setBriefError] = useState(null);
  const [isBriefExpanded, setIsBriefExpanded] = useState(true);
  const [briefTab, setBriefTab] = useState("team");

  const fetchDailyBrief = async () => {
    setIsBriefLoading(true);
    setBriefError(null);
    try {
      const managerID = user?.data?.[0]?.manager_id || user?.data?.[0]?.emp_id || 1628;
      const response = await axios.get(
        `https://h0guznseci.execute-api.us-east-1.amazonaws.com/brief?posted_to=${managerID}`
      );
      if (response.data) {
        setDailyBrief(response.data);
      } else {
        throw new Error("No brief data received");
      }
    } catch (error) {
      console.error("Error fetching daily brief:", error);
      setBriefError("Failed to load daily brief data.");
    } finally {
      setIsBriefLoading(false);
    }
  };

  useEffect(() => {
    console.log("useEffect triggered", token, user); // Check when this runs
    if (token && user?.data?.length > 0) {
      fetchData();
      fetchDailyBrief();
    } else {
      console.log("Missing token or user data", { token, user });
    }
  }, [token, user]);
  const fetchData = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(
        process.env.REACT_APP_CLIENT_GETCLIENTPOD,
        {
          method: "POST",
          headers: {
            Authorization: token,
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            clientID: user.data[0].emp_id
          })
        }
      );

      const data = await response.json();
      setPodDetails(data.data.podDetails);
      const activities = data.data.activities.sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );

      // If the API doesn't return comments, initialize with empty array
      const activitiesWithComments = activities.map(activity => ({
        ...activity,
        comments: activity.comments || '[]'
      }));

      console.log("Response received:", response.status);

      console.log("Data received:", data);
      setPodActivities(activitiesWithComments);
      setFilteredActivities(activitiesWithComments);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSort = (column) => {
    const newDirection =
      sortConfig.column === column && sortConfig.direction === 'asc'
        ? 'desc'
        : 'asc';

    setSortConfig({ column, direction: newDirection });

    const sortedActivities = [...filteredActivities].sort((a, b) => {
      if (column === 'status') {
        const statusA = a.posted_to_client === 1 ? 'Approved' : 'Pending';
        const statusB = b.posted_to_client === 1 ? 'Approved' : 'Pending';
        return newDirection === 'asc'
          ? statusA.localeCompare(statusB)
          : statusB.localeCompare(statusA);
      }

      if (column === 'createdAt') {
        const dateA = new Date(a.createdAt);
        const dateB = new Date(b.createdAt);
        return newDirection === 'asc'
          ? dateA - dateB
          : dateB - dateA;
      }

      return 0; // Default case: no sorting
    });

    setFilteredActivities(sortedActivities);
  };


  const handleApprove = async () => {
    if (selectedIds.length === 0) {
      alert(intl.formatMessage({ id: "selectItemsWarning" }));
      return;
    }

    try {
      const response = await fetch(process.env.REACT_APP_CLIENT_PODACTIVITYPOSTLEAD, {
        method: "POST",
        headers: {
          Authorization: token,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          poddata: [{ id: selectedIds, manager_id: user.data[0].emp_id }],
          manager_id: user.data[0].emp_id
        })
      });

      if (response.ok) {
        alert(intl.formatMessage({ id: "approvalSuccess" }));
        fetchData();
        setSelectedIds([]);
      } else {
        throw new Error('Approval failed');
      }
    } catch (error) {
      console.error("Error:", error);
      alert(intl.formatMessage({ id: "approvalError" }));
    }
  };


  const handleDownload = async (format) => {
    const generateCSV = () => {
      let csvContent = "data:text/csv;charset=utf-8," +
        "First Name,Categories,Jira Issue,Today's Focus,Accomplishments,Video URL,Posted Date,Status\n";

      filteredActivities.forEach((activity) => {
        const row = [
          activity.firstName,
          activity.categories,
          activity.jira_issue,
          activity.today_focus || "",
          activity.accomplishments || "",

          activity.loom_url || "",
          moment(activity.createdAt).format("MM-DD-YYYY"),
          activity.posted_to_client === 1 ? "Approved" : "Pending"
        ].map(field => `"${field}"`).join(",") + "\n";
        csvContent += row;
      });

      const link = document.createElement("a");
      link.setAttribute("href", encodeURI(csvContent));
      link.setAttribute("download", "pod_activities.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };

    const generatePDF = () => {
      if (filteredActivities.length > 0) {
        const doc = new jsPDF('landscape', 'pt', 'a4');

        // Add title
        doc.setFontSize(16);
        doc.setFont('helvetica', 'bold');
        doc.text('Pod Activities Report', 40, 40);

        // Add date range info
        doc.setFontSize(10);
        doc.setFont('helvetica', 'normal');
        const today = moment().format('MM-DD-YYYY');
        doc.text(`Generated on: ${today}`, 40, 60);
        doc.text(`Total Records: ${filteredActivities.length}`, 40, 75);

        const headers = [
          "Name",
          "Jira Issue",
          "Today's Focus",
          "Accomplishments",
          "Video",
          "Date",
          "Status"
        ];

        const rows = filteredActivities.map((activity) => [
          activity.firstName || "",
          activity.jira_issue ? (activity.jira_issue.length > 30 ?
            activity.jira_issue.substring(0, 30) + "..." :
            activity.jira_issue) : "",
          activity.today_focus ? (activity.today_focus.length > 40 ?
            activity.today_focus.substring(0, 40) + "..." :
            activity.today_focus) : "",
          activity.accomplishments ? (activity.accomplishments.length > 40 ?
            activity.accomplishments.substring(0, 40) + "..." :
            activity.accomplishments) : "",
          activity.loom_url ? "Yes" : "No",
          moment(activity.createdAt).format("MM-DD-YYYY"),
          activity.posted_to_client === 1 ? "Approved" : "Pending"
        ]);

        doc.autoTable({
          head: [headers],
          body: rows,
          startY: 90,
          styles: {
            fontSize: 8,
            cellPadding: 4,
            lineColor: [200, 200, 200],
            lineWidth: 0.1,
            textColor: [50, 50, 50]
          },
          headStyles: {
            fillColor: [41, 128, 185],
            textColor: [255, 255, 255],
            fontStyle: 'bold',
            fontSize: 9
          },
          alternateRowStyles: {
            fillColor: [245, 245, 245]
          },
          columnStyles: {
            0: { cellWidth: 80 },   // Name
            1: { cellWidth: 100 },  // Jira Issue
            2: { cellWidth: 120 },  // Today's Focus
            3: { cellWidth: 120 },  // Accomplishments
            4: { cellWidth: 50 },   // Video
            5: { cellWidth: 80 },   // Date
            6: { cellWidth: 70 }    // Status
          },
          margin: { top: 90, right: 40, bottom: 40, left: 40 },
          pageBreak: 'auto',
          showHead: 'everyPage',
          theme: 'grid'
        });

        // Add footer with page numbers
        const pageCount = doc.internal.getNumberOfPages();
        for (let i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          doc.setFontSize(8);
          doc.setFont('helvetica', 'normal');
          doc.text(
            `Page ${i} of ${pageCount}`,
            doc.internal.pageSize.width - 100,
            doc.internal.pageSize.height - 20
          );
        }

        doc.save(`pod_activities_${moment().format('YYYY-MM-DD')}.pdf`);
      }
    };
    format === "csv" ? generateCSV() : generatePDF();
    setDownloadMenuAnchor(null);
  };

  const stats = [
    {
      title: intl.formatMessage({ id: "totalActivities" }),
      value: filteredActivities.length,
      color: "#1976d2"
    },
    {
      title: intl.formatMessage({ id: "pendingApproval" }),
      value: filteredActivities.filter(a => !a.posted_to_client).length,
      color: "#ed6c02"
    },
    {
      title: intl.formatMessage({ id: "approved" }),
      value: filteredActivities.filter(a => a.posted_to_client === 1).length,
      color: "#2e7d32"
    }
  ];


  const isActivityInRange = (activity, range) => {
    // If range is null or contains null dates, it means it is not filtered by date
    if (!range || !range.startDate || !range.endDate) {
      return true;
    }

    if (!activity.createdAt) {
      return false;
    }

    const activityDate = new Date(activity.createdAt);
    const startDate = new Date(range.startDate);
    const endDate = new Date(range.endDate);

    activityDate.setHours(0, 0, 0, 0);
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);

    return activityDate >= startDate && activityDate <= endDate;
  };



  useEffect(() => {
    let results = [...podActivities];

    // Filter by Date Range
    if (dateRange && dateRange[0] && dateRange[0].startDate && dateRange[0].endDate) {
      results = results.filter(activity => isActivityInRange(activity, dateRange[0]));
    }

    // Filter by Pods
    if (selectedPodId.length > 0) {
      results = results.filter(activity =>
        selectedPodId.some(podId => podId.toString() === activity.pod_id.toString())
      );
    }

    // Filter by Team Member
    if (selectedTeamMember) {
      results = results.filter(activity => activity.firstName === selectedTeamMember);
    }

    // Filter by Status
    if (statusFilter !== "all") {
      results = results.filter(activity =>
        statusFilter === "approved" ? activity.posted_to_client === 1 : activity.posted_to_client === 0
      );
    }

    // Sort by createdAt desc by default
    results.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

    setFilteredActivities(results);
    setCurrentPage(1);
  }, [podActivities, dateRange, selectedPodId, selectedTeamMember, statusFilter]);


  const handleStatusFilterChange = (event) => {
    setStatusFilter(event.target.value);
  };

  const handlePodSelect = (event) => {
    setSelectedPodId(event.target.value);
  };

  const handleTeamMemberSelect = (event) => {
    setSelectedTeamMember(event.target.value);
  };

  const handleCheckboxChange = (event, id) => {
    setSelectedIds(prev =>
      event.target.checked
        ? [...prev, id]
        : prev.filter(selectedId => selectedId !== id)
    );
  };
  const handleCommentAdded = async (activityId, newComments) => {
    setPodActivities(prevActivities =>
      prevActivities.map(activity =>
        activity.id === activityId
          ? { ...activity, comments: newComments }
          : activity
      )
    );

    setFilteredActivities(prevActivities =>
      prevActivities.map(activity =>
        activity.id === activityId
          ? { ...activity, comments: newComments }
          : activity
      )
    );
  };
  const clearAllFilters = () => {
    setSelectedPodId([]);
    setSelectedTeamMember("");
    setStatusFilter("all");
    setDateRange([{
      startDate: null,
      endDate: null,
      key: "selection"
    }]);
    setTempDateRange([{
      startDate: moment().subtract(7, "days").toDate(),
      endDate: moment().toDate(),
      key: "selection"
    }]);
  };

  const hasActiveFilters = 
    selectedPodId.length > 0 || 
    selectedTeamMember !== "" || 
    statusFilter !== "all" || 
    (dateRange[0]?.startDate && dateRange[0]?.endDate);

  const rowsPerPage = 10;

  const totalPages = Math.ceil(filteredActivities.length / rowsPerPage);
  const paginatedActivities = filteredActivities.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );



  return (
    <div className="artemy-fade-up">

      <div style={{ marginBottom: '32px', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', flexWrap: 'wrap', gap: '16px' }}>
        <div>
          <h1 className="artemy-page-title">
            Pod Activity
          </h1>
          <p className="artemy-page-sub">
            Monitor and manage pod member activities, Jira issues, and AI updates
          </p>
        </div>

        <Box sx={{ display: 'flex', gap: 2 }}>
          <button
            className="artemy-btn artemy-btn-ghost"
            onClick={() => setShowFilters(!showFilters)}
          >
            <FilterListIcon sx={{ mr: 1, fontSize: 18 }} />
            {intl.formatMessage({ id: "filters" })}
          </button>

          <button
            className="artemy-btn artemy-btn-primary"
            onClick={(e) => setDownloadMenuAnchor(e.currentTarget)}
          >
            <DownloadIcon sx={{ mr: 1, fontSize: 18 }} />
            {intl.formatMessage({ id: "download" })}
          </button>
        </Box>
      </div>

      {/* AI Agent Daily Brief Panel */}
      {isBriefLoading ? (
        <Box sx={{
          background: 'rgba(255, 255, 255, 0.01)',
          border: '1px solid var(--artemy-border, rgba(255, 255, 255, 0.08))',
          borderRadius: '16px',
          p: 4,
          mb: 4,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2
        }}>
          <CircularProgress size={30} sx={{ color: 'var(--artemy-accent, #9b5de5)' }} />
          <Typography sx={{ color: 'var(--artemy-text-secondary)', fontFamily: 'var(--artemy-font-mono, monospace)', fontSize: '11px', letterSpacing: '0.1em' }}>
            GENERATING AI DAILY BRIEF...
          </Typography>
        </Box>
      ) : briefError ? (
        <Box sx={{
          background: 'rgba(255, 77, 106, 0.05)',
          border: '1px solid rgba(255, 77, 106, 0.15)',
          borderRadius: '16px',
          p: 3,
          mb: 4,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          <Typography color="error" variant="body2">{briefError}</Typography>
          <IconButton onClick={fetchDailyBrief} size="small" sx={{ color: 'var(--artemy-red, #ff4d6a)' }}>
            <RefreshIcon />
          </IconButton>
        </Box>
      ) : dailyBrief ? (
        <BriefContainer>
          {/* Header */}
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: isBriefExpanded ? '1px solid var(--artemy-border, rgba(255,255,255,0.08))' : 'none', pb: isBriefExpanded ? 2 : 0, mb: isBriefExpanded ? 3 : 0 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
              <AutoAwesomeIcon sx={{ color: 'var(--artemy-accent, #9b5de5)', filter: 'drop-shadow(0 0 8px rgba(155,93,229,0.5))' }} />
              <Box>
                <Typography sx={{ fontWeight: 'bold', fontSize: '16px', display: 'flex', alignItems: 'center', gap: 1 }}>
                  AI Agent Daily Brief
                  <span style={{ fontSize: '11px', fontWeight: 'normal', color: 'var(--artemy-text-dim, rgba(255,255,255,0.4))', fontFamily: 'var(--artemy-font-mono, monospace)' }}>
                    {dailyBrief.brief_date}
                  </span>
                </Typography>
                {isBriefExpanded && dailyBrief.team_brief?.generated_at && (
                  <Typography sx={{ fontSize: '10px', color: 'var(--artemy-text-dim, rgba(255,255,255,0.4))', fontFamily: 'var(--artemy-font-mono, monospace)', mt: 0.5 }}>
                    ANALYZED AT: {moment(dailyBrief.team_brief.generated_at).format('hh:mm A, MM-DD-YYYY')}
                  </Typography>
                )}
              </Box>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              {/* Dynamic Health Badge */}
              <HealthBadge health={dailyBrief.team_brief?.team_health}>
                {dailyBrief.team_brief?.team_health === 'at_risk' ? <WarningIcon style={{ fontSize: 13 }} /> : <CheckCircleIcon style={{ fontSize: 13 }} />}
                Team Health: {dailyBrief.team_brief?.team_health === 'at_risk' ? 'At Risk' : 'On Track'}
              </HealthBadge>

              <IconButton onClick={fetchDailyBrief} size="small" sx={{ color: 'var(--artemy-text-secondary)', '&:hover': { color: 'var(--artemy-accent)' } }}>
                <RefreshIcon style={{ fontSize: 18 }} />
              </IconButton>
              
              <IconButton onClick={() => setIsBriefExpanded(!isBriefExpanded)} size="small" sx={{ color: 'var(--artemy-text-secondary)' }}>
                {isBriefExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </IconButton>
            </Box>
          </Box>

          {/* Expanded Content */}
          <Collapse in={isBriefExpanded}>
            {/* Tabs */}
            <Box sx={{ display: 'flex', borderBottom: '1px solid rgba(255,255,255,0.05)', mb: 3, gap: 3 }}>
              <Button
                onClick={() => setBriefTab("team")}
                sx={{
                  color: briefTab === 'team' ? 'var(--artemy-accent, #9b5de5)' : 'var(--artemy-text-secondary)',
                  borderBottom: briefTab === 'team' ? '2px solid var(--artemy-accent, #9b5de5)' : 'none',
                  borderRadius: 0,
                  px: 2,
                  pb: 1.5,
                  textTransform: 'none',
                  fontWeight: 600,
                  fontSize: '13px',
                  '&:hover': { background: 'none', color: 'var(--artemy-accent)' }
                }}
              >
                Team Insights
              </Button>
              <Button
                onClick={() => setBriefTab("individual")}
                sx={{
                  color: briefTab === 'individual' ? 'var(--artemy-accent, #9b5de5)' : 'var(--artemy-text-secondary)',
                  borderBottom: briefTab === 'individual' ? '2px solid var(--artemy-accent, #9b5de5)' : 'none',
                  borderRadius: 0,
                  px: 2,
                  pb: 1.5,
                  textTransform: 'none',
                  fontWeight: 600,
                  fontSize: '13px',
                  '&:hover': { background: 'none', color: 'var(--artemy-accent)' }
                }}
              >
                Individual Assessments
              </Button>
            </Box>

            {briefTab === 'team' ? (
              <Box>
                {/* Team Status Summary Grid */}
                <Grid container spacing={3} sx={{ mb: 4 }}>
                  <Grid item xs={12} sm={6} md={3}>
                    <Box sx={{ p: 2, borderRadius: '10px', background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.04)', height: '100%' }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
                        <SpeedIcon sx={{ color: 'var(--artemy-accent, #9b5de5)' }} />
                        <Typography sx={{ color: 'var(--artemy-text-secondary)', fontSize: '12px', fontWeight: 600, textTransform: 'uppercase', fontFamily: 'var(--artemy-font-mono)' }}>
                          Total members
                        </Typography>
                      </Box>
                      <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
                        {dailyBrief.team_brief?.total_members || 0}
                      </Typography>
                    </Box>
                  </Grid>

                  {/* Behind Group */}
                  <Grid item xs={12} sm={6} md={3}>
                    <Box sx={{ p: 2, borderRadius: '10px', background: 'rgba(255, 77, 106, 0.04)', border: '1px solid rgba(255, 77, 106, 0.1)', height: '100%' }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
                        <TrendingDownIcon sx={{ color: '#ff4d6a' }} />
                        <Typography sx={{ color: '#ff4d6a', fontSize: '12px', fontWeight: 600, textTransform: 'uppercase', fontFamily: 'var(--artemy-font-mono)' }}>
                          Behind
                        </Typography>
                      </Box>
                      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap sx={{ gap: 1 }}>
                        {dailyBrief.team_brief?.behind?.length > 0 ? (
                          dailyBrief.team_brief.behind.map((name) => (
                            <Chip key={name} label={name} size="small" sx={{ bgcolor: 'rgba(255, 77, 106, 0.12)', color: '#ff4d6a', border: '1px solid rgba(255, 77, 106, 0.2)' }} />
                          ))
                        ) : (
                          <Typography sx={{ color: 'var(--artemy-text-dim)', fontSize: '12px', fontStyle: 'italic' }}>None</Typography>
                        )}
                      </Stack>
                    </Box>
                  </Grid>

                  {/* Needs Help Group */}
                  <Grid item xs={12} sm={6} md={3}>
                    <Box sx={{ p: 2, borderRadius: '10px', background: 'rgba(237, 108, 2, 0.04)', border: '1px solid rgba(237, 108, 2, 0.1)', height: '100%' }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
                        <HelpOutlineIcon sx={{ color: '#ed6c02' }} />
                        <Typography sx={{ color: '#ed6c02', fontSize: '12px', fontWeight: 600, textTransform: 'uppercase', fontFamily: 'var(--artemy-font-mono)' }}>
                          Needs Help
                        </Typography>
                      </Box>
                      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap sx={{ gap: 1 }}>
                        {dailyBrief.team_brief?.needs_help?.length > 0 ? (
                          dailyBrief.team_brief.needs_help.map((name) => (
                            <Chip key={name} label={name} size="small" sx={{ bgcolor: 'rgba(237, 108, 2, 0.12)', color: '#ed6c02', border: '1px solid rgba(237, 108, 2, 0.2)' }} />
                          ))
                        ) : (
                          <Typography sx={{ color: 'var(--artemy-text-dim)', fontSize: '12px', fontStyle: 'italic' }}>None</Typography>
                        )}
                      </Stack>
                    </Box>
                  </Grid>

                  {/* On Track Group */}
                  <Grid item xs={12} sm={6} md={3}>
                    <Box sx={{ p: 2, borderRadius: '10px', background: 'rgba(0, 212, 170, 0.04)', border: '1px solid rgba(0, 212, 170, 0.1)', height: '100%' }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
                        <TrendingUpIcon sx={{ color: '#00d4aa' }} />
                        <Typography sx={{ color: '#00d4aa', fontSize: '12px', fontWeight: 600, textTransform: 'uppercase', fontFamily: 'var(--artemy-font-mono)' }}>
                          On Track / Ahead
                        </Typography>
                      </Box>
                      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap sx={{ gap: 1 }}>
                        {[...(dailyBrief.team_brief?.on_track || []), ...(dailyBrief.team_brief?.ahead || [])].length > 0 ? (
                          [...(dailyBrief.team_brief.on_track || []), ...(dailyBrief.team_brief.ahead || [])].map((name) => (
                            <Chip key={name} label={name} size="small" sx={{ bgcolor: 'rgba(0, 212, 170, 0.12)', color: '#00d4aa', border: '1px solid rgba(0, 212, 170, 0.2)' }} />
                          ))
                        ) : (
                          <Typography sx={{ color: 'var(--artemy-text-dim)', fontSize: '12px', fontStyle: 'italic' }}>None</Typography>
                        )}
                      </Stack>
                    </Box>
                  </Grid>
                </Grid>

                {/* Team Risks and Blockers section */}
                <Grid container spacing={3}>
                  {/* Risks Column */}
                  <Grid item xs={12} md={6}>
                    <Box sx={{ p: 2.5, borderRadius: '12px', background: 'rgba(255,255,255,0.015)', border: '1px solid rgba(255,255,255,0.04)', height: '100%' }}>
                      <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 2, color: 'var(--artemy-text-primary)', display: 'flex', alignItems: 'center', gap: 1 }}>
                        <WarningIcon sx={{ color: '#ff4d6a', fontSize: 18 }} />
                        Active Risks ({dailyBrief.team_brief?.all_risks?.length || 0})
                      </Typography>
                      <Stack spacing={1.5}>
                        {dailyBrief.team_brief?.all_risks?.length > 0 ? (
                          dailyBrief.team_brief.all_risks.map((riskItem, idx) => (
                            <Box key={idx} sx={{ p: 1.5, borderRadius: '8px', background: 'rgba(255, 77, 106, 0.03)', border: '1px solid rgba(255, 77, 106, 0.08)', display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                              <Typography sx={{ fontSize: '12px', fontWeight: 'bold', color: '#ff4d6a' }}>
                                {riskItem.participant}
                              </Typography>
                              <Typography sx={{ fontSize: '12.5px', color: 'var(--artemy-text-secondary)' }}>
                                {riskItem.risk}
                              </Typography>
                            </Box>
                          ))
                        ) : (
                          <Box sx={{ py: 3, display: 'flex', justifyContent: 'center', opacity: 0.5 }}>
                            <Typography sx={{ fontSize: '12.5px', color: 'var(--artemy-text-dim)' }}>No active risks identified</Typography>
                          </Box>
                        )}
                      </Stack>
                    </Box>
                  </Grid>

                  {/* Blockers Column */}
                  <Grid item xs={12} md={6}>
                    <Box sx={{ p: 2.5, borderRadius: '12px', background: 'rgba(255,255,255,0.015)', border: '1px solid rgba(255,255,255,0.04)', height: '100%' }}>
                      <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 2, color: 'var(--artemy-text-primary)', display: 'flex', alignItems: 'center', gap: 1 }}>
                        <ReportProblemIcon sx={{ color: '#ed6c02', fontSize: 18 }} />
                        Active Blockers ({dailyBrief.team_brief?.all_blockers?.length || 0})
                      </Typography>
                      <Stack spacing={1.5}>
                        {dailyBrief.team_brief?.all_blockers?.length > 0 ? (
                          dailyBrief.team_brief.all_blockers.map((blocker, idx) => (
                            <Box key={idx} sx={{ p: 1.5, borderRadius: '8px', background: 'rgba(237, 108, 2, 0.03)', border: '1px solid rgba(237, 108, 2, 0.08)' }}>
                              <Typography sx={{ fontSize: '12.5px', color: 'var(--artemy-text-secondary)' }}>
                                {blocker}
                              </Typography>
                            </Box>
                          ))
                        ) : (
                          <Box sx={{ py: 3, display: 'flex', justifyContent: 'center', opacity: 0.5 }}>
                            <Typography sx={{ fontSize: '12.5px', color: 'var(--artemy-text-dim)' }}>No active blockers logged</Typography>
                          </Box>
                        )}
                      </Stack>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            ) : (
              <Box>
                {/* Individual Assessments Grid */}
                <Grid container spacing={3}>
                  {dailyBrief.participants?.map((participant) => {
                    const isBehind = participant.risk_analysis?.velocity === 'behind';
                    const needsHelp = participant.risk_analysis?.needs_help;
                    
                    return (
                      <Grid item xs={12} md={6} key={participant.candidateID}>
                        <ParticipantBriefCard>
                          <CardContent sx={{ p: 3, display: 'flex', flexDirection: 'column', gap: 2.5 }}>
                            {/* Card Header */}
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                              <Box>
                                <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'var(--artemy-text-primary)' }}>
                                  {participant.name}
                                </Typography>
                                <Typography sx={{ fontSize: '11px', color: 'var(--artemy-text-dim)', fontFamily: 'var(--artemy-font-mono, monospace)', mt: 0.5 }}>
                                  POD ID: {participant.pod_id}
                                </Typography>
                              </Box>

                              <Box sx={{ display: 'flex', gap: 1 }}>
                                <Chip
                                  label={participant.risk_analysis?.velocity || 'on_track'}
                                  size="small"
                                  sx={{
                                    textTransform: 'uppercase',
                                    fontSize: '10px',
                                    fontWeight: 'bold',
                                    bgcolor: isBehind ? 'rgba(255, 77, 106, 0.12)' : 'rgba(0, 212, 170, 0.12)',
                                    color: isBehind ? '#ff4d6a' : '#00d4aa',
                                    border: `1px solid ${isBehind ? 'rgba(255, 77, 106, 0.2)' : 'rgba(0, 212, 170, 0.2)'}`
                                  }}
                                />
                                {needsHelp && (
                                  <Chip
                                    label="Needs Help"
                                    size="small"
                                    sx={{
                                      textTransform: 'uppercase',
                                      fontSize: '10px',
                                      fontWeight: 'bold',
                                      bgcolor: 'rgba(237, 108, 2, 0.12)',
                                      color: '#ed6c02',
                                      border: '1px solid rgba(237, 108, 2, 0.2)'
                                    }}
                                  />
                                )}
                              </Box>
                            </Box>

                            {/* AI Assessment */}
                            <Box>
                              <Typography sx={{ fontSize: '11px', fontWeight: 600, color: 'var(--artemy-text-dim)', textTransform: 'uppercase', letterSpacing: '0.05em', mb: 1, fontFamily: 'var(--artemy-font-mono)' }}>
                                AI Assessment
                              </Typography>
                              <AiAssessmentBox>
                                {participant.ai_brief || 'No daily assessment generated.'}
                              </AiAssessmentBox>
                            </Box>

                            {/* Jira & GitHub Summary Indicators */}
                            <Grid container spacing={2}>
                              <Grid item xs={12} sm={6}>
                                <Box sx={{ p: 1.5, borderRadius: '8px', background: 'rgba(255,255,255,0.01)', border: '1px solid rgba(255,255,255,0.03)', display: 'flex', gap: 1.5, alignItems: 'flex-start', height: '100%' }}>
                                  <AssignmentIcon sx={{ color: '#2196f3', fontSize: 18, mt: 0.2 }} />
                                  <Box>
                                    <Typography sx={{ fontSize: '10.5px', color: 'var(--artemy-text-dim)', textTransform: 'uppercase', fontFamily: 'var(--artemy-font-mono)' }}>
                                      Jira Summary
                                    </Typography>
                                    <Typography sx={{ fontSize: '12px', color: 'var(--artemy-text-secondary)', mt: 0.5, wordBreak: 'break-word', overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical' }}>
                                      {participant.jira_summary || 'No Jira stories.'}
                                    </Typography>
                                  </Box>
                                </Box>
                              </Grid>

                              <Grid item xs={12} sm={6}>
                                <Box sx={{ p: 1.5, borderRadius: '8px', background: 'rgba(255,255,255,0.01)', border: '1px solid rgba(255,255,255,0.03)', display: 'flex', gap: 1.5, alignItems: 'flex-start', height: '100%' }}>
                                  <GitHubIcon sx={{ color: '#e8ecf4', fontSize: 18, mt: 0.2 }} />
                                  <Box>
                                    <Typography sx={{ fontSize: '10.5px', color: 'var(--artemy-text-dim)', textTransform: 'uppercase', fontFamily: 'var(--artemy-font-mono)' }}>
                                      Git Activity
                                    </Typography>
                                    <Typography sx={{ fontSize: '12px', color: 'var(--artemy-text-secondary)', mt: 0.5 }}>
                                      {participant.github_summary || 'No activity logged.'}
                                    </Typography>
                                  </Box>
                                </Box>
                              </Grid>
                            </Grid>

                            {/* Hand-written Focus and Accomplishments */}
                            {participant.pod_activity && (
                              <Box sx={{ borderTop: '1px solid rgba(255,255,255,0.04)', pt: 2, mt: 0.5 }}>
                                <Grid container spacing={2}>
                                  <Grid item xs={6}>
                                    <Typography sx={{ fontSize: '10.5px', color: 'var(--artemy-text-dim)', textTransform: 'uppercase', fontFamily: 'var(--artemy-font-mono)', mb: 0.5 }}>
                                      Today's Focus
                                    </Typography>
                                    <Typography sx={{ fontSize: '12.5px', color: 'var(--artemy-text-secondary)', fontStyle: 'normal' }}>
                                      {participant.pod_activity.today_focus || '-'}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={6}>
                                    <Typography sx={{ fontSize: '10.5px', color: 'var(--artemy-text-dim)', textTransform: 'uppercase', fontFamily: 'var(--artemy-font-mono)', mb: 0.5 }}>
                                      Accomplishments
                                    </Typography>
                                    <Typography sx={{ fontSize: '12.5px', color: 'var(--artemy-text-secondary)' }}>
                                      {participant.pod_activity.accomplishments || '-'}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Box>
                            )}
                          </CardContent>
                        </ParticipantBriefCard>
                      </Grid>
                    );
                  })}
                </Grid>
              </Box>
            )}
          </Collapse>
        </BriefContainer>
      ) : null}

      {isLoading ? (
        <LoaderWrapper>
          <CircularProgress sx={{ color: 'var(--artemy-accent)' }} />
          <Typography sx={{ color: 'var(--artemy-text-secondary)', fontFamily: 'var(--artemy-font-mono)', fontSize: '13px' }}>
            SYNCHRONIZING ACTIVITY DATA...
          </Typography>
        </LoaderWrapper>
      ) : (
        <>
          {hasActiveFilters && (
            <Box sx={{ 
              mb: 2, 
              display: 'flex', 
              alignItems: 'center', 
              gap: 1.5, 
              flexWrap: 'wrap',
              background: 'rgba(255,255,255,0.03)',
              padding: '10px 16px',
              borderRadius: '10px',
              border: '1px solid var(--artemy-border)'
            }}>
              <Typography sx={{ fontSize: 11, fontFamily: 'var(--artemy-font-mono)', color: 'var(--artemy-text-dim)', textTransform: 'uppercase', letterSpacing: 1 }}>
                Active Filters:
              </Typography>
              
              {/* Date Range Chip */}
              {dateRange[0]?.startDate && dateRange[0]?.endDate && (
                <Chip
                  icon={<DateRangeIcon style={{ fontSize: 14, color: 'var(--artemy-accent)' }} />}
                  label={`${moment(dateRange[0].startDate).format("MMM D")} - ${moment(dateRange[0].endDate).format("MMM D")}`}
                  onDelete={() => {
                    setDateRange([{ startDate: null, endDate: null, key: "selection" }]);
                    setTempDateRange([{ startDate: moment().subtract(7, "days").toDate(), endDate: moment().toDate(), key: "selection" }]);
                  }}
                  size="small"
                  sx={{ background: 'rgba(var(--artemy-primary-rgb), 0.1)', color: 'var(--artemy-text-primary)', border: '1px solid rgba(var(--artemy-primary-rgb), 0.2)' }}
                />
              )}

              {/* Pods Chip */}
              {selectedPodId.length > 0 && (
                <Chip
                  label={`Pods: ${selectedPodId.length}`}
                  onDelete={() => setSelectedPodId([])}
                  size="small"
                  sx={{ background: 'rgba(255,255,255,0.05)', color: 'var(--artemy-text-primary)' }}
                />
              )}

              {/* Team Member Chip */}
              {selectedTeamMember && (
                <Chip
                  label={`Member: ${selectedTeamMember}`}
                  onDelete={() => setSelectedTeamMember("")}
                  size="small"
                  sx={{ background: 'rgba(255,255,255,0.05)', color: 'var(--artemy-text-primary)' }}
                />
              )}

              {/* Status Chip */}
              {statusFilter !== "all" && (
                <Chip
                  label={`Status: ${statusFilter}`}
                  onDelete={() => setStatusFilter("all")}
                  size="small"
                  sx={{ background: 'rgba(255,255,255,0.05)', color: 'var(--artemy-text-primary)' }}
                />
              )}

              <Button 
                onClick={clearAllFilters}
                size="small"
                sx={{ 
                  ml: 'auto', 
                  fontSize: 11, 
                  color: 'var(--artemy-red)',
                  fontFamily: 'var(--artemy-font-mono)',
                  '&:hover': { background: 'rgba(255,77,106,0.1)' }
                }}
              >
                Clear All
              </Button>
            </Box>
          )}

          <div className="artemy-card" style={{ padding: '0', overflow: 'hidden' }}>

          {showFilters && (
            <Box sx={{ p: 3, borderBottom: '1px solid var(--artemy-border)', display: 'flex', flexWrap: 'wrap', gap: 3, bgcolor: 'rgba(255,255,255,0.02)' }}>
              <FormControl sx={{ minWidth: 200 }} size="small">
                <InputLabel sx={{ color: 'var(--artemy-text-secondary)' }}>Pods</InputLabel>
                <Select
                  multiple
                  value={selectedPodId}
                  onChange={handlePodSelect}
                  label="Pods"
                  renderValue={(selected) => {
                    if (selected.length === 0) return "All Pods";
                    return podDetails
                      .filter((pod) => selected.includes(pod.id))
                      .map((pod) => pod.podName)
                      .join(", ");
                  }}
                  sx={{
                    color: 'var(--artemy-text-primary)',
                    '.MuiOutlinedInput-notchedOutline': { borderColor: 'var(--artemy-border)' },
                    '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'var(--artemy-accent)' },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: 'var(--artemy-accent)' }
                  }}
                >
                  {podDetails.map((pod) => (
                    <MenuItem key={pod.id} value={pod.id}>
                      <Checkbox checked={selectedPodId.indexOf(pod.id) > -1} />
                      <ListItemText primary={pod.podName} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl sx={{ minWidth: 200 }} size="small">
                <InputLabel sx={{ color: 'var(--artemy-text-secondary)' }}>Team Member</InputLabel>
                <Select
                  value={selectedTeamMember}
                  onChange={handleTeamMemberSelect}
                  label="Team Member"
                  sx={{
                    color: 'var(--artemy-text-primary)',
                    '.MuiOutlinedInput-notchedOutline': { borderColor: 'var(--artemy-border)' },
                    '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'var(--artemy-accent)' },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: 'var(--artemy-accent)' }
                  }}
                >
                  <MenuItem value="">All Members</MenuItem>
                  {[...new Set(podActivities.map((activity) => activity.firstName))].map(
                    (member) => (
                      <MenuItem key={member} value={member}>
                        {member}
                      </MenuItem>
                    )
                  )}
                </Select>
              </FormControl>

              <Box sx={{ display: 'flex', gap: 1 }}>
                <button
                  className="artemy-btn artemy-btn-ghost"
                  onClick={() => setShowDateRangePicker(!showDateRangePicker)}
                >
                  <DateRangeIcon sx={{ mr: 1, fontSize: 18 }} />
                  {dateRange && dateRange[0] && dateRange[0].startDate && dateRange[0].endDate 
                    ? `${moment(dateRange[0].startDate).format("MMM D")} - ${moment(dateRange[0].endDate).format("MMM D")}`
                    : "Show All Records"
                  }
                </button>
                <Dialog open={showDateRangePicker} onClose={() => setShowDateRangePicker(false)} maxWidth="md">
                  <DialogTitle sx={{ bgcolor: 'var(--artemy-bg-elevated)', color: 'var(--artemy-text-primary)' }}>Select Date Range</DialogTitle>
                  <DialogContent sx={{ bgcolor: 'var(--artemy-bg-elevated)', p: 0 }}>
                    <DateRangePicker
                      onChange={item => setTempDateRange([item.selection])}
                      ranges={tempDateRange}
                      moveRangeOnFirstSelection={false}
                    />
                    <Box sx={{ p: 2, display: 'flex', justifyContent: 'flex-end', gap: 2, bgcolor: 'var(--artemy-bg-elevated)', borderTop: '1px solid var(--artemy-border)' }}>
                      <button className="artemy-btn artemy-btn-ghost" onClick={() => setShowDateRangePicker(false)}>
                        Cancel
                      </button>
                      <button 
                        className="artemy-btn artemy-btn-ghost" 
                        style={{ color: 'var(--artemy-red)' }}
                        onClick={() => {
                          setTempDateRange([{
                            startDate: null,
                            endDate: null,
                            key: "selection"
                          }]);
                          setDateRange([{
                            startDate: null,
                            endDate: null,
                            key: "selection"
                          }]);
                          setShowDateRangePicker(false);
                        }}
                      >
                        Clear Filter
                      </button>
                      <button 
                        className="artemy-btn artemy-btn-primary" 
                        onClick={() => {
                          setDateRange(tempDateRange);
                          setShowDateRangePicker(false);
                        }}
                      >
                        Apply Range
                      </button>
                    </Box>
                  </DialogContent>
                </Dialog>
              </Box>
            </Box>
          )}

          <div style={{ maxHeight: 'calc(100vh - 350px)', overflow: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
              <thead>
                <tr>
                  <th style={{ backgroundColor: 'var(--artemy-bg-base)', borderBottom: '1px solid var(--artemy-border)', padding: '16px', position: 'sticky', top: 0, zIndex: 1 }}>
                    <Checkbox
                      indeterminate={selectedIds.length > 0 && selectedIds.length < filteredActivities.length}
                      checked={filteredActivities.length > 0 && selectedIds.length === filteredActivities.length}
                      onChange={(e) => {
                        const ids = e.target.checked
                          ? filteredActivities
                            .filter(a => a.posted_to_client !== 1)
                            .map(a => a.id)
                          : [];
                        setSelectedIds(ids);
                      }}
                      sx={{ color: 'var(--artemy-text-secondary)' }}
                    />
                  </th>
                  <SortableTableHeader column="firstName" label="Name" sortConfig={sortConfig} onSort={handleSort} />
                  <th style={{ backgroundColor: 'var(--artemy-bg-base)', color: 'var(--artemy-text-secondary)', fontFamily: 'var(--artemy-font-mono)', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.05em', borderBottom: '1px solid var(--artemy-border)', padding: '16px', position: 'sticky', top: 0, zIndex: 1 }}>
                    Jira Issues
                  </th>
                  <th style={{ backgroundColor: 'var(--artemy-bg-base)', color: 'var(--artemy-text-secondary)', fontFamily: 'var(--artemy-font-mono)', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.05em', borderBottom: '1px solid var(--artemy-border)', padding: '16px', position: 'sticky', top: 0, zIndex: 1 }}>
                    Today's Focus
                  </th>
                  <th style={{ backgroundColor: 'var(--artemy-bg-base)', color: 'var(--artemy-text-secondary)', fontFamily: 'var(--artemy-font-mono)', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.05em', borderBottom: '1px solid var(--artemy-border)', padding: '16px', position: 'sticky', top: 0, zIndex: 1 }}>
                    Accomplishments
                  </th>
                  <th style={{ backgroundColor: 'var(--artemy-bg-base)', color: 'var(--artemy-text-secondary)', fontFamily: 'var(--artemy-font-mono)', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.05em', borderBottom: '1px solid var(--artemy-border)', padding: '16px', position: 'sticky', top: 0, zIndex: 1 }}>
                    Demo
                  </th>
                  <th style={{ backgroundColor: 'var(--artemy-bg-base)', color: 'var(--artemy-text-secondary)', fontFamily: 'var(--artemy-font-mono)', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.05em', borderBottom: '1px solid var(--artemy-border)', padding: '16px', position: 'sticky', top: 0, zIndex: 1 }}>
                    AI Analysis
                  </th>
                  <th style={{ backgroundColor: 'var(--artemy-bg-base)', color: 'var(--artemy-text-secondary)', fontFamily: 'var(--artemy-font-mono)', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.05em', borderBottom: '1px solid var(--artemy-border)', padding: '16px', position: 'sticky', top: 0, zIndex: 1 }}>
                    Chat
                  </th>
                  <SortableTableHeader column="createdAt" label="Date" sortConfig={sortConfig} onSort={handleSort} />
                  <th style={{ backgroundColor: 'var(--artemy-bg-base)', color: 'var(--artemy-text-secondary)', fontFamily: 'var(--artemy-font-mono)', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.05em', borderBottom: '1px solid var(--artemy-border)', padding: '16px', position: 'sticky', top: 0, zIndex: 1 }}>
                    Status
                  </th>
                  <th style={{ backgroundColor: 'var(--artemy-bg-base)', color: 'var(--artemy-text-secondary)', fontFamily: 'var(--artemy-font-mono)', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.05em', borderBottom: '1px solid var(--artemy-border)', padding: '16px', position: 'sticky', top: 0, zIndex: 1 }}>
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredActivities.length > 0 ? (
                  paginatedActivities.map((activity) => (
                    <EditableTableRow
                      key={activity.id}
                      activity={activity}
                      selectedIds={selectedIds}
                      handleCheckboxChange={handleCheckboxChange}
                      onSave={fetchData}
                      token={token}
                      isUserLoggedIn={isLoggedIn}
                      handleVideoClick={handleVideoClick}
                      handleCommentAdded={handleCommentAdded}
                      onAIUpdateView={handleAIUpdateView}
                      intl={intl}
                    />
                  ))
                ) : (
                  <tr>
                    <td colSpan={11} style={{ textAlign: 'center', padding: '80px 0' }}>
                      <Box sx={{ color: 'var(--artemy-text-secondary)', opacity: 0.5 }}>
                        <TableRowsIcon sx={{ fontSize: 48, mb: 2 }} />
                        <Typography variant="body1">No activities found for the selected criteria</Typography>
                      </Box>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <Box sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: '1px solid var(--artemy-border)', bgcolor: 'rgba(255,255,255,0.01)' }}>
            <Typography variant="caption" sx={{ color: 'var(--artemy-text-secondary)', fontFamily: 'var(--artemy-font-mono)', fontSize: '11px' }}>
              SHOWING {((currentPage - 1) * rowsPerPage) + 1} - {Math.min(currentPage * rowsPerPage, filteredActivities.length)} OF {filteredActivities.length} RECORDS
            </Typography>
            <Pagination
              count={totalPages}
              page={currentPage}
              onChange={(e, val) => setCurrentPage(val)}
              sx={{
                '& .MuiPaginationItem-root': { color: 'var(--artemy-text-secondary)', borderColor: 'var(--artemy-border)' },
                '& .Mui-selected': { bgcolor: 'var(--artemy-accent) !important', color: 'white' }
              }}
            />
          </Box>
        </div>
      </>
    )}

      {selectedIds.length > 0 && (
        <Box
          className="artemy-fade-up"
          sx={{
            position: 'fixed',
            bottom: 32,
            left: '50%',
            transform: 'translateX(-50%)',
            bgcolor: 'var(--artemy-bg-elevated)',
            border: '1px solid var(--artemy-accent)',
            borderRadius: '100px',
            px: 4,
            py: 1.5,
            display: 'flex',
            alignItems: 'center',
            gap: 4,
            boxShadow: '0 20px 40px rgba(0,0,0,0.5)',
            zIndex: 1000
          }}
        >
          <Typography sx={{ color: 'var(--artemy-text-primary)', fontWeight: 600 }}>
            {selectedIds.length} items selected
          </Typography>
          <Box display="flex" gap={2}>
            <button className="artemy-btn artemy-btn-ghost" onClick={() => setSelectedIds([])}>
              Cancel
            </button>
            <button className="artemy-btn artemy-btn-primary" onClick={handlePostToClient}>
              Approve & Post to Client
            </button>
          </Box>
        </Box>
      )}

      <Menu
        anchorEl={downloadMenuAnchor}
        open={Boolean(downloadMenuAnchor)}
        onClose={() => setDownloadMenuAnchor(null)}
        PaperProps={{
          sx: {
            bgcolor: 'var(--artemy-bg-elevated)',
            border: '1px solid var(--artemy-border)',
            color: 'var(--artemy-text-primary)',
            mt: 1,
            '& .MuiMenuItem-root': { px: 2, py: 1.5, '&:hover': { bgcolor: 'rgba(255,255,255,0.05)' } }
          }
        }}
      >
        <MenuItem onClick={() => { handleDownload("pdf"); setDownloadMenuAnchor(null); }}>
          <ListItemIcon><PictureAsPdfIcon sx={{ color: 'var(--artemy-red)' }} /></ListItemIcon>
          <ListItemText>Export as PDF</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => { handleDownload("csv"); setDownloadMenuAnchor(null); }}>
          <ListItemIcon><TableRowsIcon sx={{ color: 'var(--artemy-green)' }} /></ListItemIcon>
          <ListItemText>Export as CSV</ListItemText>
        </MenuItem>
      </Menu>

      <AIUpdateModal
        open={aiUpdateModalOpen}
        onClose={handleCloseAIUpdateModal}
        data={selectedAIUpdateData}
        intl={intl}
      />
    </div>
  );
};

export default PodActivity;